import { Loader2 } from 'lucide-react';
import { cn } from '../../utils/cn';
import { Logo } from '../brand/Logo';

interface SpinnerProps {
  size?: number;
  className?: string;
  label?: string;
}

export const Spinner = ({ size = 20, className, label = 'Chargement' }: SpinnerProps) => (
  <span
    role="status"
    aria-live="polite"
    className={cn('inline-flex items-center gap-2 text-brand-red', className)}
  >
    <Loader2 className="animate-spin" style={{ width: size, height: size }} aria-hidden />
    <span className="sr-only">{label}</span>
  </span>
);

export const FullPageSpinner = () => (
  <div
    role="status"
    aria-live="polite"
    className="flex min-h-[60vh] w-full flex-col items-center justify-center gap-6"
  >
    <Logo variant="banner" size="xl" />
    <Spinner size={18} label="Chargement…" />
  </div>
);
